import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

type StatusVariant = 'loading' | 'error' | 'empty';

interface StatusMessageProps {
  variant: StatusVariant;
  message?: string;
}

const defaultMessages: Record<StatusVariant, string> = {
  loading: 'Loading…',
  error: 'Something went wrong. Please try again.',
  empty: 'Nothing to show yet.'
};

const StatusMessage: React.FC<StatusMessageProps> = ({ variant, message }) => {
  const text = message || defaultMessages[variant];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        mt: 6,
        gap: 2
      }}
    >
      {variant === 'loading' && <CircularProgress />}
      <Typography
        color={variant === 'error' ? 'error' : 'text.secondary'}
        align="center"
      >
        {text}
      </Typography>
    </Box>
  );
};

export default StatusMessage;

